var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.listData), function(item) {
    return [_c('md-card', {
      staticClass: "card",
      attrs: {
        "md-with-hover": ""
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-subhead"
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n        " + _vm._s(item.content) + "\n      ")])], 1)]
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-069d6992","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Saying.vue
// module id = omXd
// module chunks = 1